import styled from 'styled-components';
import Image from '@components/Image';

const UserImage = styled(Image)`
  border-radius: 50%;
  min-width: 32px;
  width: 32px;
  height: 32px;
`;

export default UserImage;
